export default "__VITE_ASSET__Cff__XLR__"